import { Inject, Injectable } from '@angular/core';
import { QueryStringService } from './query-string.service';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})

export class ScriptInjectorService {

  constructor(private queryStringHandler: QueryStringService, @Inject(DOCUMENT) private dom: Document,) { }


  private getScriptToInject(src: string): HTMLScriptElement {
    const script = this.dom.createElement('script');
    script.type = 'text/javascript';
    script.src = src;
    script.async = true;
    return script;
  }

  injectABtastyScript() {
    const qsp = this.queryStringHandler.getParameter('disableabtasty');
    if (qsp != 'true') {
      const script = this.getScriptToInject('https://try.abtasty.com/709389f5f152d448ed658c06bdf96458.js');
      this.dom.head.insertBefore(script, this.dom.head.firstChild);
    }
  }
}
